export default {
  data() {
    return {
      mq: {},
    };
  },

  created() {
    this.mq = window.matchMedia('(min-width: 780px)');
    this.mq.addListener(() => {
      if (this.onMqChange && typeof this.onMqChange === 'function') {
        this.onMqChange();
      }
      this.$forceUpdate();
    });
  },

  methods: {
    isDesktop() {
      return this.mq.matches;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/mediaQuery.js